import makeRequest from 'utils/makeRequest';
import { ACTIVITY_ACCRUE_MAP, ACTIVITY_MAXCAP_MAP } from 'constants/index';
import {
  fetchAllActivitiesMapping,
  NP_DOMAIN,
} from 'modules/WithTimesPoint/config';
import Cookie from '../../utils/cookies';

export const VIDEO_SUCCESS_EVENT = 'VIDEO_SUCCESS_EVENT';
export const TP_LOGIN_EVENT = 'LOGIN_EVENT_ACTIVITY';
export function SaveActivityToLocalStorage(acode, msid) {
  if (typeof window.localStorage === 'undefined') {
    return;
  }

  try {
    let accrueObj = localStorage.getItem(ACTIVITY_ACCRUE_MAP);

    if (!accrueObj) {
      accrueObj = {};
    } else {
      accrueObj = JSON.parse(accrueObj);
    }
    if (accrueObj[acode]) {
      accrueObj[acode].push(msid);
    } else {
      accrueObj[acode] = [msid];
    }
    window.localStorage.setItem(ACTIVITY_ACCRUE_MAP, JSON.stringify(accrueObj));
  } catch (e) {
    // console.log(e);
  }
}
export function sendActivityRequest(request, cb) {
  // replacing server call with client call
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  makeRequest
    .post(
      `${NP_DOMAIN}/timespoint/submit/activity/toi`,
      JSON.stringify(request),
      config,
    )
    .then(response => {
      if (response.data.status === '"FAILURE"') {
        // console.log(data.message);
      } else {
        // console.log(
        //   'TPActivity Post Login Activity URL -https://tpapi.timespoints.com/v1/activity/logact' +
        //     request,
        // );
      }
      if (response && response.data && response.data.success) {
        SaveActivityToLocalStorage(request.aname, request.txnId);
        cb(response);
      }
    })
    .catch(() => {
      //console.log(err);
    });
}

export function resetDailyCheckInEntries(isWapView) {
  const AllActivitiesMapping = fetchAllActivitiesMapping(isWapView);
  if (typeof window.localStorage !== 'undefined') {
    let achievedActConfig = {};
    try {
      achievedActConfig = localStorage.getItem(ACTIVITY_ACCRUE_MAP);
      const dailyCheckInAName =
        AllActivitiesMapping && AllActivitiesMapping.dailycheckin
          ? AllActivitiesMapping.dailycheckin
          : '';
      if (!achievedActConfig || !dailyCheckInAName) {
        return;
      }
      achievedActConfig = JSON.parse(achievedActConfig);
      if (
        achievedActConfig &&
        achievedActConfig[dailyCheckInAName] &&
        achievedActConfig[dailyCheckInAName].length > 0
      ) {
        achievedActConfig[dailyCheckInAName] = [];
        window.localStorage.setItem(
          ACTIVITY_ACCRUE_MAP,
          JSON.stringify(achievedActConfig),
        );
      }
    } catch (e) {
      // console.log(e);
    }
  }
}

export function checkAccrualStatusActivity(msid, acode) {
  if (typeof window.localStorage === 'undefined') {
    return true;
  }

  let activityMap = {};
  let achievedActConfig = {};
  let isValidActivity = false;
  try {
    activityMap = window.localStorage.getItem(ACTIVITY_MAXCAP_MAP);
    achievedActConfig = localStorage.getItem(ACTIVITY_ACCRUE_MAP);
    if (!activityMap) {
      return true;
    }

    activityMap = JSON.parse(activityMap);
    achievedActConfig = JSON.parse(achievedActConfig);
    if (!activityMap || !activityMap[acode]) {
      isValidActivity = true;
    } else {
      let dateVal =
        achievedActConfig && achievedActConfig.date
          ? achievedActConfig.date
          : '';
      const currDate = new Date();
      const curDate = [
        currDate.getDate(),
        currDate.getMonth(),
        currDate.getFullYear(),
      ];
      const curDateStr = curDate.join('-');
      if (curDateStr !== dateVal) {
        dateVal = curDateStr;
        isValidActivity = true;
        achievedActConfig = {};
        achievedActConfig.date = dateVal;
        window.localStorage.setItem(
          ACTIVITY_ACCRUE_MAP,
          JSON.stringify(achievedActConfig),
        );
      } else if (
        !achievedActConfig ||
        !achievedActConfig[acode] ||
        (achievedActConfig[acode].length < activityMap[acode] &&
          achievedActConfig[acode].indexOf(msid) === -1)
      ) {
        isValidActivity = true;
      }
    }
  } catch (e) {
    isValidActivity = true;
    // console.log(e);
  }

  return isValidActivity;
}

export function getEmail() {
  const email = Cookie.get('MSCSAuthDetails')
    ? Cookie.get('MSCSAuthDetails').split('=')[1]
    : '';
  return email;
}
export function getSsoid() {
  const ssoid = Cookie.get('ssoid');
  return ssoid;
}
export function getTicketid() {
  const ticketid = Cookie.get('TicketId');
  return ticketid;
}
export function handleActivity(
  activity,
  txnId,
  userTypeId,
  cb,
  isMobile = false,
) {
  const newTPconfig = { pcode: 'TOI', scode: 'TOI', uid: getSsoid() };
  const pfm = isMobile ? 'msite' : 'web';
  const AllActivitiesMapping = fetchAllActivitiesMapping(isMobile);
  const request = {
    pcode: `${newTPconfig.pcode}`,
    scode: `${newTPconfig.scode}`,
    aname: `${AllActivitiesMapping[activity] || ''}`,
    // aname: `${activity}`,
    txnId: `${txnId}`,
    apiVersion: `23`,
    clientId: `TOI`,
    platform: `${pfm}`,
  };

  if (!request.aname) {
    return;
  }

  const innerFn = data => {
    // eslint-disable-next-line default-case
    switch (userTypeId) {
      case 'deviceid':
        request.deviceId = data;
        break;
      case 'ssoid':
        request.uid = data;
        break;
    }
    if (
      checkAccrualStatusActivity(
        txnId,
        AllActivitiesMapping[activity],
        activity === 'dailycheckin',
      )
    ) {
      sendActivityRequest(request, cb);
    }
  };

  if (userTypeId === 'deviceid') {
    if (typeof window.tpsdk === 'undefined') {
      window.tpsdk = function() {
        (window.tpsdk.q = window.tpsdk.q || []).push(arguments);
      };
      window.tpsdk.l = 1 * new Date();
      window.tpsdk = window.tpsdk || {};
    }
    window.tpsdk('init', {
      platform: pfm,
      channelCode: 'TOI',
    });
    window.tpsdk('getDeviceId', innerFn);
  } else {
    innerFn(`${getSsoid()}`);
  }
}
export function fireActivity(isMobile = false, activity, txnId, cb) {
  if (typeof getSsoid() !== 'string') {
    handleActivity(activity, txnId, 'deviceid', cb, isMobile);
  } else {
    handleActivity(activity, txnId, 'ssoid', cb, isMobile);
  }
}
export function shareHandlingForTimesPoints(type, msid, isMobile) {
  if (typeof type === 'string' && type.indexOf('facebook') >= 0) {
    fireActivity(isMobile, 'sh_fb', `fb_${msid}`);
  }
  if (typeof type === 'string' && type.indexOf('twitter') >= 0) {
    fireActivity(isMobile, 'sh_tw', `tw_${msid}`);
  }
}
export function postLoginActions() {
  const newTPconfig = {
    pcode: 'TOI',
    scode: 'TOI',
    uid: getSsoid(),
    email: getEmail(),
  };

  const mergeTpDataForLoggedInUser = deviceId => {
    if (!deviceId) {
      return;
    }
    const request = {
      uid: getSsoid(),
      pcode: 'TOI',
      platform: 'web',
      clientId: 'TOI',
      deviceId,
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    makeRequest.post(
      `${NP_DOMAIN}/timespoint/init/toi`,
      JSON.stringify(request),
      config,
    );
  };

  if (typeof window.tpsdk === 'function') {
    window.tpsdk('getDeviceId', mergeTpDataForLoggedInUser);
  }

  return (
    window.TPWidget &&
    window.TPWidget.PostLoginActions({
      host: newTPconfig.pcode,
      channel: newTPconfig.scode,
      URL: escape(document.location.href),
      userId: newTPconfig.uid,
      oid: '',
      email: newTPconfig.email,
    })
  );
}
export function valiDateLocalStorageConfigData() {
  if (typeof localStorage === 'object') {
    const acheivedActConfig = JSON.parse(
      localStorage.getItem('acheivedActConfig'),
    );
    if (acheivedActConfig instanceof Object) {
      const date = new Date();
      const configDate = `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
      // eslint-disable-next-line radix
      if (acheivedActConfig.date !== configDate) {
        localStorage.removeItem('acheivedActConfig');
      }
    }
  }
}

export function getAssignedPoint(activityType, allActivity, isWapView) {
  const AllActivitiesMapping = fetchAllActivitiesMapping(isWapView);
  if (!allActivity || !allActivity.length) return -1;
  const activityCode = AllActivitiesMapping[activityType];
  for (let i = 0; i < allActivity.length; i += 1) {
    if (
      allActivity[i] &&
      typeof allActivity[i].code === 'string' &&
      allActivity[i].code.toLowerCase() === activityCode.toLowerCase()
    ) {
      return allActivity[i].assign_points || -1;
    }
  }
  return -1;
}
